import { CashRequestMiddleware } from './types'

export const deviceNameRequest: CashRequestMiddleware = request => {
  const headers = request.headers as Record<string, string>

  headers['X-Device-Name'] = 'Browser'

  return request
}
